// import useMediaQuery from "@material-ui/core/useMediaQuery";

// export const matches = useMediaQuery("(min-width:600px)");

export const mobileView = window.matchMedia("(max-width: 600px)").matches;
